import "./base-theme/breakpoints.js";
import "theme-ui";
import "./base-theme/components/collapsible.js";
import "./base-theme/components/dialogs.js";
import "./base-theme/components/forms/forms.js";
import "./base-theme/components/forms/input.js";
import "./base-theme/components/skeletons.js";
import "./base-theme/components/tags.js";
import "./base-theme/components/toast.js";
import "./base-theme/components/tooltips.js";
import "./base-theme/keyframes.js";
import { outline as r } from "./base-theme/outline.js";
import "./base-theme/theme.js";
const y = (o = {}) => r({ color: "primary", ...o });
export {
  y as outline
};
